module.exports = require("module");